module.exports = __webpack_public_path__ + "static/media/uk_flag.abaa85da.svg";